module.exports = __webpack_public_path__ + "img/instagram-icon.27bf7ca.svg";